/**
 * @generated SignedSource<<19726eb6a0aac322d97f5728129d7453>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceAsideQuery$variables = {
  owner: string;
  slug: string;
};
export type WorkspaceAsideQuery$data = {
  readonly workspaceBySlug: {
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceAsideFragment">;
  } | null | undefined;
};
export type WorkspaceAsideQuery = {
  response: WorkspaceAsideQuery$data;
  variables: WorkspaceAsideQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "owner"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Event",
  "kind": "LinkedField",
  "name": "event",
  "plural": false,
  "selections": [
    (v9/*:: as any*/),
    (v2/*:: as any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": "viewerCanCreateVersion",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_WORKSPACE_VERSION"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_WORKSPACE_VERSION\")"
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceAsideQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspaceBySlug",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceAsideFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "WorkspaceAsideQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspaceBySlug",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "license",
            "storageKey": null
          },
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "private",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "concreteType": "WorkspaceVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkspaceVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DOI",
                        "kind": "LinkedField",
                        "name": "doi",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "full",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "short",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                          (v5/*:: as any*/),
                          (v6/*:: as any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isEntity"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "imageThumbnail",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*:: as any*/),
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkspaceVersion",
                        "kind": "LinkedField",
                        "name": "clonedFrom",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          (v7/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Workspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              (v9/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Competition",
                        "kind": "LinkedField",
                        "name": "fromCompetition",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          (v10/*:: as any*/),
                          (v9/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v4/*:: as any*/),
                            "concreteType": "EventCompetitionConnection",
                            "kind": "LinkedField",
                            "name": "events",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventCompetition",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v11/*:: as any*/),
                                  (v2/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "events(first:1)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompetitionStage",
                            "kind": "LinkedField",
                            "name": "currentStage",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "noCode",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "submissionDeadline",
                                "storageKey": null
                              },
                              (v2/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "viewerCanPublish",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "action",
                            "value": "PUBLISH_WORKSPACE_VERSION"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "viewerCan",
                        "storageKey": "viewerCan(action:\"PUBLISH_WORKSPACE_VERSION\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Workspace",
                        "kind": "LinkedField",
                        "name": "workspace",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          (v9/*:: as any*/),
                          (v12/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v13/*:: as any*/),
                        "concreteType": "SubmissionConnection",
                        "kind": "LinkedField",
                        "name": "submissions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Submission",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v2/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                  (v5/*:: as any*/),
                                  (v6/*:: as any*/),
                                  (v2/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompetitionStage",
                                "kind": "LinkedField",
                                "name": "stage",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "seq",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v4/*:: as any*/),
                                    "concreteType": "EventCompetitionConnection",
                                    "kind": "LinkedField",
                                    "name": "events",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventCompetition",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                          (v11/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Competition",
                                            "kind": "LinkedField",
                                            "name": "competition",
                                            "plural": false,
                                            "selections": [
                                              (v9/*:: as any*/),
                                              (v10/*:: as any*/),
                                              (v2/*:: as any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v2/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "events(first:1)"
                                  },
                                  (v2/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "submissions(first:50)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bibtex",
                        "storageKey": null
                      },
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*:: as any*/)
                ],
                "storageKey": null
              },
              (v15/*:: as any*/)
            ],
            "storageKey": "versions(first:1)"
          },
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "filters": null,
            "handle": "connection",
            "key": "WorkspaceAsideFragment_versions",
            "kind": "LinkedHandle",
            "name": "versions"
          },
          {
            "alias": "viewerCanEdit",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "UPDATE_WORKSPACE"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"UPDATE_WORKSPACE\")"
          },
          (v9/*:: as any*/),
          (v12/*:: as any*/),
          {
            "alias": "baseVersions",
            "args": (v13/*:: as any*/),
            "concreteType": "WorkspaceVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceVersion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "versions(first:50)"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "tagList",
                "args": (v16/*:: as any*/),
                "concreteType": "TaggableConnection",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Tag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v14/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v15/*:: as any*/)
                ],
                "storageKey": "tags(first:5)"
              },
              {
                "alias": "tagList",
                "args": (v16/*:: as any*/),
                "filters": null,
                "handle": "connection",
                "key": "TagListFragment_tagList",
                "kind": "LinkedHandle",
                "name": "tags"
              }
            ],
            "type": "Taggable",
            "abstractKey": "__isTaggable"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9f935390bb74d2494f0e01e6a7a4bbff",
    "id": null,
    "metadata": {},
    "name": "WorkspaceAsideQuery",
    "operationKind": "query",
    "text": "query WorkspaceAsideQuery(\n  $owner: String!\n  $slug: String!\n) {\n  workspaceBySlug(owner: $owner, slug: $slug) {\n    ...WorkspaceAsideFragment\n    id\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment TagFragment on Tag {\n  name\n}\n\nfragment TagListFragment on Taggable {\n  __isTaggable: __typename\n  tagList: tags(first: 5) {\n    totalCount\n    edges {\n      node {\n        id\n        ...TagFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment WorkspaceAsideFragment on Workspace {\n  id\n  shortDescription\n  license\n  createdAt\n  private\n  versions(first: 1) {\n    edges {\n      node {\n        id\n        doi {\n          full\n        }\n        entity {\n          __typename\n          username\n          ...EntityProfilePicFragment_49kWkb\n          id\n        }\n        createdAt\n        version\n        publishedAt\n        clonedFrom @ifAllowed {\n          id\n          version\n          workspace {\n            id\n            slug\n          }\n        }\n        fromCompetition @ifAllowed {\n          id\n          title\n          slug\n          events(first: 1) {\n            nodes {\n              event {\n                slug\n                id\n              }\n              id\n            }\n          }\n        }\n        ...WorkspaceVersionCardActionsFragment\n        ...WorkspaceDOIFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...TagListFragment\n  ...WorkspaceMetadataEditButtonFragment\n  ...WorkspaceVersionHistoryFragment\n}\n\nfragment WorkspaceDOIFragment on WorkspaceVersion {\n  id\n  bibtex\n  doi {\n    full\n    short\n    url\n  }\n}\n\nfragment WorkspaceMetadataEditButtonFragment on Workspace {\n  id\n  shortDescription\n  license\n  ...TagListFragment\n  ...taggableFragment\n  viewerCanEdit: viewerCan(action: UPDATE_WORKSPACE)\n}\n\nfragment WorkspacePublishButtonFragment on Workspace {\n  id\n  viewerCanCreateVersion: viewerCan(action: CREATE_WORKSPACE_VERSION)\n  baseVersions: versions(first: 50) {\n    nodes {\n      id\n      version\n      publishedAt\n    }\n  }\n}\n\nfragment WorkspaceVersionCardActionsFragment on WorkspaceVersion {\n  id\n  version\n  publishedAt\n  viewerCanPublish: viewerCan(action: PUBLISH_WORKSPACE_VERSION)\n  workspace {\n    id\n    slug\n    viewerCanCreateVersion: viewerCan(action: CREATE_WORKSPACE_VERSION)\n  }\n  fromCompetition @ifAllowed {\n    id\n    title\n    slug\n    currentStage {\n      noCode\n      submissionDeadline\n      id\n    }\n    events(first: 1) {\n      nodes {\n        event {\n          slug\n          id\n        }\n        id\n      }\n    }\n  }\n  submissions(first: 50) {\n    nodes {\n      id\n      entity {\n        __typename\n        username\n        id\n      }\n      stage {\n        seq\n        events(first: 1) {\n          nodes {\n            event {\n              slug\n              id\n            }\n            competition {\n              slug\n              title\n              id\n            }\n            id\n          }\n        }\n        id\n      }\n    }\n  }\n  ...WorkspaceVersionPublishButtonFragment\n}\n\nfragment WorkspaceVersionHistoryFragment on Workspace {\n  id\n  slug\n  createdAt\n  ...WorkspacePublishButtonFragment\n}\n\nfragment WorkspaceVersionPublishButtonFragment on WorkspaceVersion {\n  id\n  version\n  publishedAt\n  viewerCanPublish: viewerCan(action: PUBLISH_WORKSPACE_VERSION)\n}\n\nfragment taggableFragment on Taggable {\n  __isTaggable: __typename\n  tagList: tags(first: 5) {\n    totalCount\n    edges {\n      node {\n        name\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "7e0b4b34662e18c69039fb550a3212a7";

export default node;
